import * as React from "react";
import { Icon, IconInput } from "./Icon";

/**
 * Search + filter bar, ported from ScadsysIdentity's users/UsersToolbar.tsx: an input with an
 * absolutely-positioned icon, and filters as `aria-pressed` toggle pills declared as data.
 */

export const Toolbar: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = "" }) => (
    <div className={`mb-4 flex flex-wrap items-center gap-3 ${className}`}>{children}</div>
);

export interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    label?: string;
}

export const SearchInput: React.FC<SearchInputProps> = ({ value, onChange, placeholder = "Search...", className = "", label = "Search" }) => (
    <div className={`relative min-w-56 flex-1 ${className}`}>
        <Icon icon={["fad", "magnifying-glass"]} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-text-weak" />
        <input
            type="search"
            aria-label={label}
            value={value}
            placeholder={placeholder}
            onChange={(e) => onChange(e.target.value)}
            className="block w-full rounded-input border-[1.5px] border-border-strong bg-surface py-2 pl-9 pr-3 text-sm text-text transition-colors duration-150 ease-out placeholder:text-text-weak focus:border-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        />
    </div>
);

export interface FilterPillProps {
    label: React.ReactNode;
    active: boolean;
    onToggle: () => void;
    icon?: IconInput;
}

export const FilterPill: React.FC<FilterPillProps> = ({ label, active, onToggle, icon }) => (
    <button
        type="button"
        aria-pressed={active}
        onClick={onToggle}
        className={`inline-flex items-center gap-1.5 rounded-pill border-[1.5px] px-3 py-1.5 text-xs font-medium transition-colors duration-150 ease-out ${
            active
                ? "border-primary bg-primary-soft text-primary-text"
                : "border-border-strong bg-surface text-text-weak hover:bg-surface-hover"
        }`}
    >
        {icon && <Icon icon={icon} />}
        {label}
    </button>
);
